<template>
	<div class="login">
		<div class="login-content">
			<h2 class="login-content-title">Reset Password</h2>
			<form class="login-form" @submit.prevent="resetPassowrd">
				<label for="password">
					<input type="password" id="password" placeholder="New Password" v-model="userInfo.password" required>
				</label>
				<label for="password-confirm">
					<input type="password" id="password-confirm" placeholder="Confirm New Password" v-model="userInfo.passwordConfirm" required>
				</label>
				<input type="submit" value="Save" >
			</form>
			<div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import CheckApi from '@/api'

export default {
	name: "Login",
	data() {
		return {
			userInfo: {
				password: '',
				passwordConfirm: '',
			},
			errorMessage: ''
		}
	},
	mounted() {
		if (!this.$route.query.q) {
			this.$router.push('/login')
		}
	},
	methods: {
		async resetPassowrd() {
			const {
				password,
				passwordConfirm
			} = this.userInfo
			if (password === passwordConfirm) {
				const data = {
					password,
					resetPasswordString: this.$route.query.q
				}
				const response = await CheckApi.handleResetPassword(data)
				if (response.status === 400) {
					this.errorMessage = response.data.data.message
				} else {
					this.$router.push('/login')
				}
			} else {
				Vue.notify({
					group: 'error',
					type: 'error',
					title: 'Error occurred',
					text: 'Password and Confirm Password fields should be the same'
				})
			}
		}
	}
}
</script>

<style scoped lang="scss">
.error-message {
	color: red;
	text-align: center;
}


.login-title {
	padding: 25px 0;
	margin: 0;
	text-align: center;
}

.login-form {
	max-width: 400px;
	margin: 0 auto;
	padding: 0 15px;
}

.login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.login-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2em;
}

.login-content-title {
  margin-bottom: 1.25em;
  text-align: center;
  font-weight: 700;
}

.login-content {
  padding-top: 50px;
  padding-bottom: 50px;
  padding-left: 50px;
  padding-right: 50px;
  background: #ffffff;
  box-shadow: 0 22px 34px rgba(174, 181, 190, 0.0936954);
  border-radius: 12px;
  width: 483px;
  height: auto;
}

.login-form-text-field {
  margin-bottom: 1.25em;
}

.login-logo {
  margin-bottom: 1em;
}

.error-message {
	margin-top: 10px;
}
</style>
